"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapEntityListRequest = mapEntityListRequest;
function mapEntityListRequest(props, { filterData, sortColumnKey, sortColumnDesc, offset, limit }) {
    const filter = props.storageClientFilter ? [...props.storageClientFilter] : [];
    if (props.fullTextSearchField) {
        const fullTextSearchValue = filterData?.[props.fullTextSearchField];
        if (typeof fullTextSearchValue === 'string' && fullTextSearchValue) {
            filter.push({ column: props.fullTextSearchField, op: 'full-text-query', value: fullTextSearchValue });
        }
    }
    if (props.mapFilter && filterData) {
        const customFilter = props.mapFilter(filterData);
        if (customFilter) {
            filter.push(...customFilter);
        }
    }
    return {
        filter: filter,
        orderBy: sortColumnKey ? [{ column: sortColumnKey, desc: sortColumnDesc }] : undefined,
        offset,
        limit,
    };
}
